const FunctionalService = {
    CALENDLY: 'ca',
};
const AnalyticalService = {
    AWIN: 'aw',
    CRAZY_EGG: 'ce',
    DATADOG: 'dd',
    GOOGLE_ANALYTICS: 'ga',
    TOPI: 'tp',
};
const MarketingService = {
    /** @deprecated Since 1.4.0, use Service.META */
    FACEBOOK: 'fb',
    GOOGLE_MARKETING_PIXEL: 'gmp',
    /** @deprecated Since 1.4.0, use Service.GOOGLE_MARKETING_PIXEL */
    GOOGLE_ADS: 'gad',
    /** @deprecated Since 1.4.0, use Service.GOOGLE_MARKETING_PIXEL */
    GOOGLE_DISPLAY_VIDEO_360: 'gdv',
    JOBSTER: 'js',
    KEVEL: 'kk',
    LINKEDIN: 'li',
    META: 'fb',
    MICROSOFT_ADVERTISING: 'ma',
    /** @deprecated Since 1.4.0, no replacement */
    PINTEREST: 'pr',
    REDDIT: 'rd',
    SNAPCHAT: 'sc',
    TIKTOK: 'tt',
};
export const Service = {
    ...FunctionalService,
    ...AnalyticalService,
    ...MarketingService,
};
/** @deprecated Since 1.3.0, use Service */
export const Vendor = { ...Service };
export const ANALYTICAL_COOKIE_SERVICES = [
    AnalyticalService.AWIN,
    AnalyticalService.CRAZY_EGG,
    AnalyticalService.DATADOG,
    AnalyticalService.GOOGLE_ANALYTICS,
    AnalyticalService.TOPI,
];
/** @deprecated Since 1.3.0, use ANALYTICAL_COOKIE_SERVICES */
export const ANALYTICAL_COOKIE_VENDORS = ANALYTICAL_COOKIE_SERVICES;
export const MARKETING_COOKIE_SERVICES = [
    MarketingService.GOOGLE_MARKETING_PIXEL,
    MarketingService.GOOGLE_ADS,
    MarketingService.GOOGLE_DISPLAY_VIDEO_360,
    MarketingService.JOBSTER,
    MarketingService.KEVEL,
    MarketingService.LINKEDIN,
    MarketingService.META,
    MarketingService.MICROSOFT_ADVERTISING,
    MarketingService.PINTEREST,
    MarketingService.REDDIT,
    MarketingService.SNAPCHAT,
    MarketingService.TIKTOK,
];
/** @deprecated Since 1.3.0, use MARKETING_COOKIE_SERVICES */
export const MARKETING_COOKIE_VENDORS = MARKETING_COOKIE_SERVICES;
export const FUNCTIONAL_COOKIE_SERVICES = [FunctionalService.CALENDLY];
/** @deprecated Since 1.3.0, use FUNCTIONAL_COOKIE_SERVICES */
export const FUNCTIONAL_COOKIE_VENDORS = FUNCTIONAL_COOKIE_SERVICES;
export const COOKIE_PREFERENCES_2023 = '20231107';
export const COOKIE_PREFERENCES_2025 = '20250507';
//# sourceMappingURL=types.js.map